import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'rule-source-condition',
  templateUrl: './rule-source-condition.component.html',
  styleUrls: ['./rule-source-condition.component.scss']
})
export class RuleSourceConditionComponent {

  @Input() item: any;

  constructor() {
  }

  isNodesExists(value): boolean {
    return value && value.nodes && value.nodes.length > 0;
  }

  isPConExists(value): boolean {
    return value && value.pcons && value.pcons.length > 0;
  }

  isReroutePConExists(value): boolean {
    return value && value.reroutePcons && value.reroutePcons.length > 0;
  }

  isUserGroupsExists(value): boolean {
    return value && value.userGroups && value.userGroups.length > 0;
  }

  isCustomersExists(value): boolean {
    return value && value.sourceCustomers && value.sourceCustomers.length > 0;
  }

  useAllCustomers(value): boolean {
    return value && value.allSourceCustomers;
  }

  isResourceGroupExist(value): boolean {
    return value && value.resourceGroups && value.resourceGroups.length > 0;
  }

  isRRAttributesExists(value, parameter): any {
    switch (parameter) {
      case 'general'     :
        return value && value.rrAttrs;
      case 'host'        :
        return value.rrAttrs.attributes.host && value.rrAttrs.attributes.host.length > 0;
      case 'prefix'      :
        return value.rrAttrs.attributes.prefix && value.rrAttrs.attributes.prefix.length > 0;
      case 'prefixGroups':
        return value.rrAttrs.attributeGroups && value.rrAttrs.attributeGroups.length > 0;
    }
  }

}
